export default class AbortControl {
  constructor() {
    this.controller = null;
  }

  get signal() {
    return this.controller?.signal;
  }

  newSignal() {
    if (this.controller) this.controller.abort();
    this.controller = new AbortController();
    return this.controller.signal;
  }

  abort() {
    if (this.controller) {
      this.controller.abort();
      this.controller = null;
    }
  }

  static isAbortError(error) {
    return error?.name === 'CanceledError' || error?.name === 'AbortError';
  }
}
